    <button mat-raised-button
            color="warn"
            matTooltip="Remove {{selectedUser.firstName}} {{selectedUser.lastName}} from the {{brandingService.title}} application. This will remove their MyEOB user and vendor associations."
            (click)="confirmRemoveUser()">
        <span class="material-icons">delete_forever</span>
            Delete User
    </button>
